import { useQuery } from 'react-query';
import { useOneTimeFetch } from 'src/hooks/useOneTimeFetch';
import { queryPresets } from 'src/queries/base';
import {
    DASHBOARD_RESOURCES,
    GET_MORTGAGE_LOAN_APP_BY_SSN,
    GQLDescribeLoanDetails,
    GQLDescribeTeamMembers,
    GQLGetBusiness,
    GQLGetLoanAppByNamespaceRole,
} from 'src/services/grapqlQueries/loanAppQuery';
import { getLoanAppUpdateQuery } from 'src/services/grapqlQueries/loanAppQueryBatch';
import { GQLQueryBuilder, QueryData } from 'src/services/grapqlQueries/queryBuilder';
import { getNamespaceName } from 'src/services/objects/namespaces';
import { ServiceAPIBuilder } from 'src/services/serviceBuilder';
import { isNotEmpty } from 'src/utilities/hasValue';
import { LOAN_PERMISSIONS_AND_ACTIVITY, AUTHENTICATED_USERS_LOANAPPS } from './useQuery';
import { OBJECT_META } from 'src/services/constants';
import { pathOr } from 'ramda';

export const queryKey = 'loanApp';
export const teamMemberQueryKey = 'teamMember'

export const useLoanAppByNamespaceRole = (
    variables: any,
    enabled: boolean = true
) => {
    const accountId = pathOr('', [OBJECT_META, 'account'], variables)
    // TODO: we have to fetch with oneTime and clear cache in case we have to validate with new list of loanapps
    return useQuery<any, any>([AUTHENTICATED_USERS_LOANAPPS, accountId], () => GQLGetLoanAppByNamespaceRole(variables), {
        ...queryPresets.oneTimeFetch,
        enabled,
        retry: true,
    });
};


export const updateLoanAppDetails = async (
    loanAppId: string,
    loanVariables: any,
    specEntities: string[],
    dispatch: any,
    setLoading: any
) => {
    try {
        const serviceData = getLoanAppUpdateQuery(specEntities, loanVariables)
        const serviceBuilder = new ServiceAPIBuilder(loanAppId, serviceData)
        await serviceBuilder.requestRedux(dispatch);
    }
    catch (err) {
        // reportException(`<-----------loanApp.tss-51---------->${err}`);
    }
    finally {
        setLoading(false)
    }
};

export const describeLoanAppDetails = (
    loanAppId: string,
    variables: any,
    queryKey: string,
    hasMortgage: boolean,
    enabled: boolean = true
) => {
    return useQuery<any, any>([queryKey, `${loanAppId}_describeloanapp`],
        () => {
            const result = GQLDescribeLoanDetails(variables, hasMortgage);
            return result;
        },
        {
            ...queryPresets.noRetry,
            enabled,
        });
};

export const describeDashboardDetails = (
    variables: any,
    hasMortgage: boolean,
    enabled: boolean = true
) => {
    const fn = () => GQLDescribeLoanDetails(
        variables,
        hasMortgage,
        DASHBOARD_RESOURCES)

    return useQuery<any, any>([queryKey, variables], fn, {
        ...queryPresets.oneTimeFetch,
        enabled,
        retry: true,
    });
};

export const describeOverViewDetails = (
    variables: any,
    loanAppId: string,
    enabled: boolean = true
) => {
    const fn = () => GQLDescribeTeamMembers(variables)
    return useQuery<any, any>([`teamMemberQueryKey-${loanAppId}`, variables], fn, {
        ...queryPresets.oneTimeFetch,
        enabled,
        retry: true,
    });
};


export const describeBusinessDetails = (
    ein: any,
    enabled: boolean = true
) => {
    const variables = {
        ein,
        objectMeta: {
            namespace: getNamespaceName()
        }
    }
    return useQuery<any, any>([`${queryKey}-${ein}`, variables], () => GQLGetBusiness(variables), {
        ...queryPresets.oneTimeFetch,
        enabled,
        retry: true,
    });
};


export const useLoanAppHistoryBySSNAndLoanPermissions = (
    ssn: any,
    loanAppId: string,
    accountId: string
) => {
    const namespace = getNamespaceName()
    const queries = []
    const historyQuery: QueryData = {
        name: 'loans_history_by_ssn',
        query: GET_MORTGAGE_LOAN_APP_BY_SSN,
        variables: {
            profile: {
                social_security_no: ssn
            },
            objectMeta: {
                namespace
            }
        }
    }

    if (isNotEmpty(ssn)) {
        queries.push(historyQuery)
    }



    const gQueryBuilder = new GQLQueryBuilder(queries, 'getLoanPermissionAndHistory')

    return useOneTimeFetch(gQueryBuilder, [], [LOAN_PERMISSIONS_AND_ACTIVITY, loanAppId]
    )
}